import { render, staticRenderFns } from "./rightData.vue?vue&type=template&id=3d465e98&scoped=true"
import script from "./rightData.vue?vue&type=script&lang=js"
export * from "./rightData.vue?vue&type=script&lang=js"
import style0 from "./rightData.vue?vue&type=style&index=0&id=3d465e98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d465e98",
  null
  
)

export default component.exports